import { render, staticRenderFns } from "./FirstEmpty.vue?vue&type=template&id=3c33d706&scoped=true"
import script from "./FirstEmpty.vue?vue&type=script&lang=js"
export * from "./FirstEmpty.vue?vue&type=script&lang=js"
import style0 from "./FirstEmpty.vue?vue&type=style&index=0&id=3c33d706&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c33d706",
  null
  
)

export default component.exports